export const PAPEL_FORM_TITLE = "Novo papel";
export const PAPEL_EDIT_FORM_TITLE_PREFIX = "Editar papel:";
export const PAPEL_NAME_LABEL = "Nome do papel";
export const PAPEL_NAME_MAX_LENGTH = 50;
export const PAPEL_NAME_LOCKED_HINT =
  "O nome não pode ser alterado porque o papel já está aplicado.";
export const FIELD_REQUIRED_MESSAGE = "Campo obrigatório";
export const VALOR_INVALID_MESSAGE = "Informe um número inteiro maior ou igual a zero";

export const OBRIGATORIO_QUESTION = "Este papel é obrigatório na obra?";
export const JANELA_QUESTION = "Em que período ele deve ser alocado na obra?";
export const JANELA_HINT =
  "Marque quando o profissional acompanha o início ou o término da obra. Se não, defina a distância em relação a um marco.";

export const OBRIGATORIO_OPTIONS = [
  { label: "Sim, obrigatório", value: true },
  { label: "Não, opcional", value: false },
];

export const PAPEL_DISCARD_TITLE = "Descartar alterações?";
export const PAPEL_DISCARD_MESSAGE = "As alterações feitas neste papel serão perdidas.";
export const PAPEL_DISCARD_ACCEPT_LABEL = "Descartar";
export const PAPEL_DISCARD_REJECT_LABEL = "Continuar editando";
